<script>
import Layout from "../../../../layouts/main";
import SupplyTicket from "./supply_ticket.vue";
import Payout from "./payout.vue";
import OutletOps from "./outletops.vue";
import Retraining from "./retraining.vue";
import axios from "axios";
import { TicketsPath, ImagesPath } from "@/path.js";
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    SupplyTicket,
    Payout,
    OutletOps,
    Retraining,
  },
  data() {
    return {
      form: {},
      ticketText: "Raise ticket",
      selectedDate: "",
      selected_category: null,
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      options: [
        { value: null, text: "Select Category" },
        { value: "supply", text: "Supply" },
        { value: "payout", text: "Payout" },
        { value: "pos", text: "Prime (UrbanPiper)" },
        { value: "signage", text: "Signage Board" },
        { value: "outlet_ops", text: "Outlet Operations" },
        { value: "retraining", text: "Chef Training" },
        { value: "product_suggestion", text: "Product Suggestion" },
        { value: "others", text: "Others" },
      ],
      selected_pos_issue: null,
      pos_issues: [
        {
          value: null,
          text: "Select Issue",
        },
        {
          value: "not_working",
          text: "Not Working",
        },
        {
          value: "can't_login",
          text: "Unable to Login",
        },
        {
          value: "can't_see_orders",
          text: "Can't see orders",
        },
        {
          value: "receiving_orders_after_operational_hours",
          text: "Receiving orders after operational hours",
        },
        {
          value: "not_getting_notifications",
          text: "Not getting notifications",
        },
        {
          value: "turned_off_the_items_still_receiving_orders",
          text: "Turned off items but still receiving orders",
        },
        {
          value: "kot_issue",
          text: "KOT / Invoice Issue",
        },
        {
          value: "others",
          text: "Others",
        },
      ],
      selected_signage_issue: null,
      signage_issues: [
        {
          value: null,
          text: "Select Issue",
        },
        {
          value: "Fix Signage",
          text: "Fix Signage",
        },
        {
          value: "Signage Light not working",
          text: "Signage Light not working",
        },
        {
          value: "didn't_receive_signage_board",
          text: "Didn't receive signage board",
        },
        {
          value: "others",
          text: "Others",
        },
      ],
      order_id_of_turned_off_item: "",
      uploaded_file_path: [],
      others_description: "",
      files: [],
      showSelectedPosIssueAlert: false,
      showSelectedSignageIssueAlert: false,
      showUploadedFileAlert: false,
      showPosSignageOthersDiscAlert: false,
      showOthersDiscAlert: false,
      showTurnedOffItemOrderAlert: false,
      minDate: new Date(2023, 0, 1),
      maxDate: new Date(2023, 11, 31),
    };
  },
  computed: {
    TicketsPath() {
      return TicketsPath;
    },
  },
  watch: {
    selected_category() {
      this.showSelectedPosIssueAlert = false;
      this.showSelectedSignageIssueAlert = false;
      this.showUploadedFileAlert = false;
      this.showPosSignageOthersDiscAlert = false;
      this.showOthersDiscAlert = false;
      this.others_description = "";
      this.uploaded_file_path = [];
      this.files = [];
      if (this.selected_category == "product_suggestion") {
        this.ticketText = "Submit";
      }
    },
    // uploaded_file_path() {
    //   this.uploaded_file_path = "";
    // },
    selected_pos_issue() {
      this.showSelectedPosIssueAlert = false;
      this.showUploadedFileAlert = false;
      this.others_description = "";
      this.showPosSignageOthersDiscAlert = false;
      this.showTurnedOffItemOrderAlert = false;
    },
    selected_signage_issue() {
      this.showSelectedSignageIssueAlert = false;
    },
    uploaded_file_path() {
      this.showUploadedFileAlert = false;
    },
    order_id_of_turned_off_item() {
      this.showTurnedOffItemOrderAlert = false;
    },
  },
  methods: {
    async saveTicket() {
      let details;
      if (this.selected_category == "pos") {
        if (!this.selected_pos_issue) {
          this.showSelectedPosIssueAlert = true;
          return;
        }
        details = {
          issue: this.selected_pos_issue,
          file: this.uploaded_file_path,
        };
        if (
          this.selected_pos_issue == "others" ||
          this.selected_pos_issue == "kot_issue"
        ) {
          if (!this.others_description) {
            this.showPosSignageOthersDiscAlert = true;
            return;
          }
          details.Description = this.others_description;
        } else if (
          this.selected_pos_issue ==
          "turned_off_the_items_still_receiving_orders"
        ) {
          if (!this.order_id_of_turned_off_item) {
            this.showTurnedOffItemOrderAlert = true;
            return;
          }
          details.orderId = this.order_id_of_turned_off_item;
        } else {
          if (!this.uploaded_file_path.length) {
            this.showUploadedFileAlert = true;
            return;
          }
        }
      } else if (this.selected_category == "signage") {
        if (!this.selected_signage_issue) {
          this.showSelectedSignageIssueAlert = true;
          return;
        }
        details = {
          issue: this.selected_signage_issue,
          file: this.uploaded_file_path,
        };
        if (this.selected_signage_issue == "others") {
          if (!this.others_description) {
            this.showPosSignageOthersDiscAlert = true;
            return;
          }
          details.Description = this.others_description;
        } else if (
          this.selected_signage_issue != "didn't_receive_signage_board"
        ) {
          if (!this.uploaded_file_path.length) {
            this.showUploadedFileAlert = true;
            return;
          }
        }
      } else if (
        this.selected_category == "others" ||
        this.selected_category == "product_suggestion"
      ) {
        details = {
          issue: this.selected_signage_issue,
          Description: this.others_description,
        };
        if (!this.others_description) {
          this.showOthersDiscAlert = true;
          return;
        }
      }
      try {
        let res = await axios.post(this.base_url + TicketsPath.SAVE_TICKET, {
          category: this.selected_category,
          extra_details: details,
        });
        if (res.data.status) {
          if (this.selected_category == "product_suggestion") {
            Swal.fire(
              "Thank you for your suggestion. We will take your feedback into consideration.",
              "",
              "success"
            ).then(() => {
              this.$router.push("/tickets_dashboard");
            });
          } else {
            Swal.fire("Ticket Raised Successfully", "", "success").then(() => {
              this.$router.push("/tickets_dashboard");
            });
          }
        } else {
          throw new Error("Failed to save");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async saveFile(e) {
      this.files.push(e.target.files[0]);
      try {
        let formData = new FormData();
        formData.append("file", e.target.files[0]);
        formData.append("folder", "tickets");
        let res = await axios.post(
          this.base_url + ImagesPath.UPLOAD_IMAGE,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status) {
          this.uploaded_file_path.push(res.data.data.file);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<template>
  <Layout>
    <b-row>
      <b-col>
        <h2 style="color: teal">Support System</h2>
      </b-col>
    </b-row>
    <b-row v-if="!selected_category">
      <b-col>
        <a href="#/tickets_dashboard">
          <b-button
            variant="primary"
            style="
              margin-block: 10px;
              padding-block: 5px;
              padding-inline: 10px;
              margin-left: 20px;
            "
            class="ml-1 ml-md-3"
          >
            <div style="display: flex; align-items: center; gap: 10px">
              <p style="font-size: 16px">View Tickets</p>
            </div>
          </b-button>
        </a>
      </b-col>
    </b-row>
    <b-row v-if="selected_category">
      <b-col>
        <b-button
          variant="success"
          style="margin-block: 10px; padding-block: 5px; padding-inline: 10px"
          @click="selected_category = null"
        >
          <div style="display: flex; align-items: center; gap: 10px">
            <i class="fa fa-arrow-left"></i>
            <p style="font-size: 16px">Back</p>
          </div>
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="selected_category">
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-form-group label="Category:">
          <b-form-select
            v-model="selected_category"
            :options="options"
            disabled
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      style="
        align-items: end;
        color: black;
        font-size: 16px;
        margin-inline: 0px !important;
      "
      class="row-container my-1 my-sm-4"
      v-if="!selected_category"
    >
      <!-- <b-col sm="8" md="6" lg="6" xl="4">
        <b-form-group label="Category:">
          <b-form-select
            v-model="selected_category"
            :options="options"
          ></b-form-select>
        </b-form-group>
      </b-col> -->
      <b-col cols="4" sm="2" class="card-container">
        <b-card
          style="text-align: center; cursor: pointer"
          class="supply rounded-lg"
          @click="selected_category = 'supply'"
        >
          <img src="./chest_freezer.jpg" alt="" height="100%" width="100%" />
          <h3 style="height: 40px; margin-top: 10px" class="responsive-heading">
            Supply
          </h3>
        </b-card>
      </b-col>
      <b-col cols="4" sm="2" class="card-container">
        <b-card
          style="color: red; text-align: center; cursor: pointer"
          class="supply rounded-lg"
          @click="selected_category = 'payout'"
        >
          <img src="./payout.png" alt="" height="100%" width="100%" />
          <h3 style="height: 40px; margin-top: 10px" class="responsive-heading">
            Payout
          </h3>
        </b-card>
      </b-col>
      <b-col cols="4" sm="2" class="card-container">
        <b-card
          style="color: red; text-align: center; cursor: pointer"
          class="supply rounded-l"
          @click="selected_category = 'pos'"
        >
          <img src="./urbanpiper.png" alt="" height="100%" width="100%" />
          <h3 style="height: 40px; margin-top: 10px" class="responsive-heading">
            Prime
          </h3>
        </b-card>
      </b-col>
      <b-col cols="4" sm="2" class="card-container">
        <b-card
          style="color: red; text-align: center; cursor: pointer"
          class="supply rounded-lg"
          @click="selected_category = 'signage'"
        >
          <img src="./signageboard.png" alt="" height="100%" width="100%" />
          <h3 style="height: 40px; margin-top: 10px" class="responsive-heading">
            Signage Board
          </h3>
        </b-card>
      </b-col>
      <b-col cols="4" sm="2" class="card-container">
        <b-card
          style="color: red; text-align: center; cursor: pointer"
          class="supply rounded-lg"
          @click="selected_category = 'outlet_ops'"
        >
          <img
            src="./restaurant_operations.jpg"
            alt=""
            height="115%"
            width="115%"
          />
          <h3 style="height: 40px; margin-top: 10px" class="responsive-heading">
            Outlet Operations
          </h3>
        </b-card>
      </b-col>
      <b-col cols="4" sm="2" class="card-container">
        <b-card
          style="color: red; text-align: center; cursor: pointer"
          class="supply rounded-lg"
          @click="selected_category = 'retraining'"
        >
          <img src="./chef_retraining.webp" alt="" height="100%" width="100%" />
          <h3 style="height: 40px; margin-top: 10px" class="responsive-heading">
            Chef Retraining
          </h3>
        </b-card>
      </b-col>
      <b-col cols="4" sm="2" class="card-container">
        <b-card
          style="color: red; text-align: center; cursor: pointer"
          class="supply rounded-lg"
          @click="selected_category = 'product_suggestion'"
        >
          <img src="./suggestion.png" alt="" height="100%" width="100%" />
          <h3 style="height: 40px; margin-top: 10px" class="responsive-heading">
            Product Suggestion
          </h3>
        </b-card>
      </b-col>
      <b-col cols="4" sm="2" class="card-container">
        <b-card
          style="
            color: red;
            text-align: center;
            cursor: pointer;
            overflow: hidden;
          "
          class="supply rounded-lg"
          @click="selected_category = 'others'"
        >
          <img src="./other.webp" alt="" height="100%" width="100%" />
          <h3 style="height: 40px; margin-top: 10px" class="responsive-heading">
            Other Issues
          </h3>
        </b-card>
      </b-col>
    </b-row>
    <template v-if="selected_category == 'supply'">
      <SupplyTicket></SupplyTicket>
    </template>
    <template v-if="selected_category == 'payout'">
      <Payout
        :category="selected_category"
        @setForm="(v) => (this.form = v)"
      ></Payout>
    </template>
    <template v-if="selected_category == 'pos'">
      <b-row style="color: black; font-size: 16px">
        <b-col sm="8" md="6" lg="6" xl="4">
          <b-form-group label="Select Issue:">
            <b-form-select
              v-model="selected_pos_issue"
              :options="pos_issues"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="
          selected_pos_issue == 'turned_off_the_items_still_receiving_orders'
        "
        style="color: black; font-size: 16px"
      >
        <b-col sm="8" md="6" lg="6" xl="4">
          <b-form-group label="Order Id:">
            <b-form-input
              placeholder="Enter Complete Order Id"
              v-model="order_id_of_turned_off_item"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="
          selected_pos_issue == 'others' || selected_pos_issue == 'kot_issue'
        "
        style="color: black; font-size: 16px"
      >
        <b-col sm="8" md="6" lg="6" xl="4">
          <b-form-group label="Description:">
            <b-form-textarea
              id="textarea"
              v-model="others_description"
              placeholder="Please type your issue..."
              rows="6"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        style="margin-bottom: 10px"
        v-if="selected_pos_issue == 'can\'t_login'"
      >
        <b-col sm="8" md="6" lg="6" xl="4">
          <div
            style="
              background-color: rgb(240, 240, 240);
              border-radius: 10px;
              padding: 10px;
              font-size: 16px;
            "
          >
            Note:- If you forgot your password try resetting password in prime
            by getting otp to registered mobile number. If you still face any
            issue's raise ticket.
          </div>
        </b-col>
      </b-row>
      <b-row
        style="color: black; font-size: 16px"
        v-if="
          selected_pos_issue != 'turned_off_the_items_still_receiving_orders' &&
          selected_pos_issue != 'kot_issue'
        "
      >
        <b-col sm="8" md="6" lg="6" xl="4">
          <b-form-group label="Please Click a Picture and Upload:">
            <b-form-file
              accept="image/*"
              @change="saveFile($event)"
              multiple
            ></b-form-file>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="selected_pos_issue == 'not_getting_notifications'">
        <b-col sm="8" md="6" lg="6" xl="4">
          <div
            style="
              background-color: rgb(240, 240, 240);
              border-radius: 10px;
              padding: 10px;
              font-size: 16px;
            "
          >
            Note:- <br />
            -- Go to session settings. <br />
            -- Click on notifications. <br />
            -- Send screenshot of page.
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="selected_pos_issue == 'not_working' && !uploaded_file_path.length"
      >
        <b-col sm="8" md="6" lg="6" xl="4">
          <div
            style="
              background-color: rgb(240, 240, 240);
              border-radius: 10px;
              padding: 10px;
              font-size: 16px;
            "
          >
            Note:- Please upload screeshot of app or website.
          </div>
        </b-col>
      </b-row>
      <b-row
        style="margin-bottom: 10px"
        v-if="selected_pos_issue == 'can\'t_see_orders'"
      >
        <b-col sm="8" md="6" lg="6" xl="4">
          <div
            style="
              background-color: rgb(240, 240, 240);
              border-radius: 10px;
              padding: 10px;
              font-size: 16px;
            "
          >
            Note:- Please share the screenshot of orders page.
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="selected_pos_issue == 'receiving_orders_after_operational_hours'"
      >
        <b-col sm="8" md="6" lg="6" xl="4">
          <div
            style="
              background-color: rgb(240, 240, 240);
              border-radius: 10px;
              padding: 5px;
              font-size: 16px;
            "
          >
            Note:- Please share orders page screenshot with order Id's visible.
          </div>
        </b-col>
      </b-row>
      <b-row
        style="margin-bottom: 10px"
        v-if="selected_pos_issue == 'can\'t_login'"
      >
        <b-col sm="8" md="6" lg="6" xl="4">
          <div
            style="
              background-color: rgb(240, 240, 240);
              border-radius: 10px;
              padding: 10px;
              font-size: 16px;
            "
          >
            Note:- Please send the login page screen shot with error message.
          </div>
        </b-col>
      </b-row>
      <b-row v-if="files.length">
        <b-col sm="8" md="6" lg="6" xl="4">
          <p
            v-for="file in files"
            :key="file"
            style="padding-bottom: 5px; color: rgba(0, 0, 200)"
          >
            {{ file.name }}
          </p>
        </b-col>
      </b-row>
    </template>
    <template v-if="selected_category == 'signage'">
      <b-row style="color: black; font-size: 16px">
        <b-col sm="8" md="6" lg="6" xl="4">
          <b-form-group label="Select Issue:">
            <b-form-select
              v-model="selected_signage_issue"
              :options="signage_issues"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="selected_signage_issue == 'others'"
        style="color: black; font-size: 16px"
      >
        <b-col sm="8" md="6" lg="6" xl="4">
          <b-form-group label="Description:">
            <b-form-textarea
              id="textarea"
              v-model="others_description"
              placeholder="Please type your issue..."
              rows="6"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        style="color: black; font-size: 16px"
        v-if="selected_signage_issue != 'didn\'t_receive_signage_board'"
      >
        <b-col sm="8" md="6" lg="6" xl="4">
          <b-form-group label="Please click a picture and Upload:">
            <b-form-file
              accept="image/*"
              @change="saveFile($event)"
              multiple
            ></b-form-file>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="files.length">
        <b-col sm="8" md="6" lg="6" xl="4">
          <p
            v-for="file in files"
            :key="file"
            style="padding-bottom: 5px; color: rgba(0, 0, 200)"
          >
            {{ file.name }}
          </p>
        </b-col>
      </b-row>
    </template>
    <template v-if="selected_category == 'outlet_ops'">
      <OutletOps :ticketText="ticketText"></OutletOps>
    </template>
    <template v-if="selected_category == 'retraining'">
      <Retraining :ticketText="ticketText"></Retraining>
    </template>
    <template v-if="selected_category == 'product_suggestion'">
      <b-row style="align-items: end; color: black; font-size: 16px">
        <b-col sm="8" md="6" lg="6" xl="6">
          <b-form-group label="Description:">
            <b-form-textarea
              id="textarea"
              v-model="others_description"
              placeholder="Enter something..."
              rows="6"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8" md="6" lg="6" xl="6">
          <div
            style="
              background-color: rgb(240, 240, 240);
              border-radius: 10px;
              padding: 10px;
              font-size: 16px;
            "
          >
            Note:- Please provide any suggestions regarding items and brands,
            such as any item you would like to add, remove, or modify.
          </div>
        </b-col>
      </b-row>
    </template>
    <template v-if="selected_category == 'others'">
      <b-row style="align-items: end; color: black; font-size: 16px">
        <b-col sm="8" md="6" lg="6" xl="6">
          <b-form-group label="Description:">
            <b-form-textarea
              id="textarea"
              v-model="others_description"
              placeholder="Enter something..."
              rows="6"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8" md="6" lg="6" xl="4">
          <div
            style="
              background-color: rgb(240, 240, 240);
              border-radius: 10px;
              padding: 10px;
              font-size: 16px;
            "
          >
            Note:- Use this if you do not find any category for your problem.
          </div>
        </b-col>
      </b-row>
    </template>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert
          v-model="showSelectedPosIssueAlert"
          variant="danger"
          dismissible
        >
          Please Select the Issue and Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert
          v-model="showPosSignageOthersDiscAlert"
          variant="danger"
          dismissible
        >
          Please enter the description and Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert v-model="showUploadedFileAlert" variant="danger" dismissible>
          Please Upload a File and Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert
          v-model="showTurnedOffItemOrderAlert"
          variant="danger"
          dismissible
        >
          Please Enter the order Id
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert
          v-model="showSelectedSignageIssueAlert"
          variant="danger"
          dismissible
        >
          Please Select the Issue and Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row v-if="selected_category == 'product_suggestion'">
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert v-model="showOthersDiscAlert" variant="danger" dismissible>
          Please write any suggestion and Submit.
        </b-alert>
      </b-col>
    </b-row>
    <b-row v-if="selected_category != 'product_suggestion'">
      <b-col sm="8" md="6" lg="6" xl="4">
        <b-alert v-model="showOthersDiscAlert" variant="danger" dismissible>
          Please enter the description and Raise Ticket
        </b-alert>
      </b-col>
    </b-row>
    <b-row
      v-if="!selected_category"
      style="margin-bottom: 100px"
      class="ml-0 ml-sm-2"
    >
      <b-col sm="8" md="6" lg="6" xl="4">
        <div
          style="
            background-color: rgb(240, 240, 240);
            border-radius: 10px;
            padding: 10px;
          "
        >
          Note:- Please select 'Others' only if you do not find a category for
          your problem.
        </div>
      </b-col>
    </b-row>
    <b-row
      v-if="
        selected_category &&
        ticketText &&
        selected_category != 'supply' &&
        selected_category != 'payout' &&
        selected_category != 'outlet_ops' &&
        selected_category != 'retraining'
      "
      style="margin-bottom: 100px"
      class="text-right text-sm-left"
    >
      <b-col>
        <b-button variant="primary" class="mt-2" @click="saveTicket">{{
          ticketText
        }}</b-button>
      </b-col>
    </b-row>
  </Layout>
</template>
<style scoped>
.custom-control-input {
  font-size: 20px !important;
}

.supply {
  transition: all 0.2s;
}

.supply:hover {
  transform: scale(1.1);
  color: black;
}
.responsive-heading {
  font-size: 14px; /* Default font size for small screens */
}
.card-container {
  padding-inline: 5px !important;
}
.row-container {
  margin-inline: 0px;
}

@media (min-width: 576px) {
  .responsive-heading {
    font-size: 14px; /* Font size for screens ≥ 576px (sm) */
  }
  .card-container {
    padding-inline: 10px !important;
  }
  .row-container {
    margin-inline: 10px !important;
  }
}

@media (min-width: 768px) {
  .responsive-heading {
    font-size: 16px; /* Font size for screens ≥ 768px (md) */
  }
  .card-container {
    padding-inline: 10px !important;
  }
}

@media (min-width: 1200px) {
  .card-container {
    padding-inline: 20px !important;
  }
}
.card-body {
  padding: 0px !important;
}
</style>
